import "./AssetInspectionModalImages.scss"

import { FC, useMemo, useState } from "react"

import { Flex } from "components/Flex"
import PictureGalleryModal from "components/PictureGalleryModal/PictureGalleryModal"
import ImageCollection from "models/ImageCollection"
import { IPictureGalleryItem } from "components/PictureGallery/PictureGallery"

interface IAssetInspectionModalImageViewerProps {
    collection: ImageCollection
}

const AssetInspectionModalImageViewer: FC<IAssetInspectionModalImageViewerProps> = ({
    collection,
}) => {
    const [activeImageIndex, setActiveImageIndex] = useState<number | null>(null)

    const pictureGalleryItems: IPictureGalleryItem[] = useMemo(() => {
        return collection.images?.map((image, index) => ({
            index,
            image,
            date: collection.collectionDate,
            tags: collection.tags,
        })) ?? []
    }, [collection.collectionDate, collection.images, collection.tags])

    if (!collection.images?.length) {
        return null
    }

    return (
        <>
            <Flex alignItems="center" wrap="wrap" gap="1rem">
                {collection.images.map((image, index) => (
                    <div key={index} className="asset-inspection-modal-images__thumb">
                        <button
                            type="button"
                            className="asset-inspection-modal-images__thumb-btn"
                            data-testid="thumb-btn"
                            onClick={() => setActiveImageIndex(index)} />
                        <img
                            src={image.thumbnailUri}
                            className="asset-inspection-modal-images__thumb-img"
                            data-testid="thumb-img"
                            alt="" />
                    </div>
                ))}
            </Flex>
            {activeImageIndex !== null &&
                <PictureGalleryModal
                    pictureGallery={{
                        items: pictureGalleryItems,
                        activeIndex: activeImageIndex,
                    }}
                    onClose={() => setActiveImageIndex(null)}
                />
            }
        </>
    )
}

export default AssetInspectionModalImageViewer
